(function () {
  if (customElements.get('nl-cross-sell')) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CSS = ".nlx{display:block;margin:1.6rem 0 0;padding:1.6rem;border-radius:18px;background:#E8F5D6}.nlx[hidden]{display:none}.nlx-title{margin:0 0 1.2rem;font-family:'Figtree',sans-serif;font-weight:800;font-size:1.5rem;color:#1F4D2B;letter-spacing:0}.nlx-list{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:1rem}.nlx--page .nlx-list{display:grid;grid-template-columns:repeat(auto-fill,minmax(260px,1fr))}.nlx-item{display:flex;align-items:center;gap:1.2rem;background:#fff;border-radius:14px;padding:.8rem 1rem}.nlx-img{flex:none;width:5.6rem;height:5.6rem;border-radius:10px;background:#fff;display:flex;align-items:center;justify-content:center;overflow:hidden}.nlx-img img{max-width:100%;max-height:100%;object-fit:contain;height:auto;mix-blend-mode:multiply}.nlx-name{flex:1;min-width:0;display:flex;flex-direction:column;gap:.2rem;text-decoration:none;color:#1B2A1F;font-size:1.35rem;font-weight:700;line-height:1.3}.nlx-name>span:first-child{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}.nlx-price{display:flex;gap:.6rem;align-items:baseline;font-weight:400}.nlx-price b{font-weight:800;font-size:1.4rem}.nlx-price s{font-size:1.2rem;color:#777}.nlx-add{flex:none;font:inherit;font-weight:700;font-size:1.25rem;background:#1F4D2B;color:#fff;border:0;border-radius:999px;padding:.9rem 1.3rem;cursor:pointer;white-space:nowrap}.nlx-add:hover{background:#2B6339}.nlx-add:disabled{opacity:.6;cursor:default}.nlx--page{margin:0 0 2.4rem;padding:2.4rem}.nlx--page .nlx-title{font-family:'Caprasimo',serif;font-weight:400;font-size:2.6rem}.nlx--cards{background:transparent;padding:0;margin:0}.nlx--cards .nlx-title{font-family:'Caprasimo',serif;font-weight:400;font-size:clamp(2.6rem,3vw,3.4rem);margin:0}";
  if (!document.getElementById('nlx-css')) { var st = document.createElement('style'); st.id = 'nlx-css'; st.textContent = CSS; document.head.appendChild(st); }
  function money(cents) { return '$' + Math.round(cents / 100).toLocaleString('es-CO'); }
  function esc(t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function norm(p, fromCollection) {
    var v = (p.variants || []).find(function (x) { return x.available; }) || (p.variants || [])[0];
    if (!v) return null;
    var price = fromCollection ? Math.round(parseFloat(v.price) * 100) : (typeof v.price === 'number' ? v.price : p.price);
    var cmp = fromCollection ? (v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0) : (v.compare_at_price || p.compare_at_price || 0);
    var img = fromCollection ? (p.images && p.images[0] && p.images[0].src) : (p.featured_image || (p.images && p.images[0]));
    if (img && typeof img === 'object') img = img.src || img.url;
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    return { pid: p.id, vid: v.id, available: fromCollection ? v.available : (p.available !== false && v.available !== false), title: p.title, url: (fromCollection ? root + 'products/' + p.handle : p.url), img: img, price: price, cmp: cmp };
  }
  function imgTag(p, w) { return p.img ? '<img src="' + p.img + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=' + w + '" alt="" loading="lazy" width="' + w + '" height="' + w + '">' : ''; }
  class NlCrossSell extends HTMLElement {
    connectedCallback() {
      if (this._done) return; this._done = true;
      var ids = (this.dataset.ids || '').split(',').filter(Boolean).map(Number);
      this.exclude = new Set(ids);
      this.limit = parseInt(this.dataset.limit || '3', 10);
      this.load(ids);
    }
    async fetchJSON(url) { try { var r = await fetch(url); if (!r.ok) return null; return await r.json(); } catch (e) { return null; } }
    async load(ids) {
      var out = [], seen = new Set(), self = this;
      function push(list, fromCol) { (list || []).forEach(function (p) { if (out.length >= self.limit) return; var n = norm(p, fromCol); if (!n || !n.available || self.exclude.has(n.pid) || seen.has(n.pid)) return; seen.add(n.pid); out.push(n); }); }
      for (var i = 0; i < Math.min(ids.length, 2) && out.length < this.limit; i++) {
        var c = await this.fetchJSON(root + 'recommendations/products.json?product_id=' + ids[i] + '&limit=10&intent=complementary');
        push(c && c.products);
        if (out.length < this.limit) { var r = await this.fetchJSON(root + 'recommendations/products.json?product_id=' + ids[i] + '&limit=10&intent=related'); push(r && r.products); }
      }
      if (out.length < this.limit && this.dataset.fallback) {
        var f = await this.fetchJSON(root + 'collections/' + this.dataset.fallback + '/products.json?limit=30');
        push(f && f.products, true);
      }
      if (out.length < this.limit && this.dataset.fallback !== 'mas-vendidos-1') {
        var g = await this.fetchJSON(root + 'collections/mas-vendidos-1/products.json?limit=30');
        push(g && g.products, true);
      }
      if (!out.length) { this.hidden = true; return; }
      this.render(out);
    }
    render(items) {
      var list = this.querySelector('[data-list]');
      var cards = this.dataset.style === 'cards';
      list.innerHTML = items.map(function (p) {
        var off = p.cmp > p.price ? Math.floor((p.cmp - p.price) * 100 / p.cmp) : 0;
        if (cards) {
          return '<li class="nlc"><a class="nlc-img" href="' + p.url + '">' + imgTag(p, 400) + (off ? '<span class="nlc-off">-' + off + '%</span>' : '') + '</a>' +
            '<a class="nlc-name" href="' + p.url + '">' + esc(p.title) + '</a><span class="nlc-stock">Disponible</span>' +
            '<div class="nlc-foot"><span class="nlc-price"><b>' + money(p.price) + '</b>' + (off ? '<s>' + money(p.cmp) + '</s>' : '') + '</span>' +
            '<button type="button" class="nlc-add" data-vid="' + p.vid + '">+ Agregar</button></div></li>';
        }
        return '<li class="nlx-item"><a class="nlx-img" href="' + p.url + '">' + imgTag(p, 160) + '</a>' +
          '<a class="nlx-name" href="' + p.url + '"><span>' + esc(p.title) + '</span><span class="nlx-price"><b>' + money(p.price) + '</b>' + (off ? '<s>' + money(p.cmp) + '</s>' : '') + '</span></a>' +
          '<button type="button" class="nlx-add" data-vid="' + p.vid + '">+ Agregar</button></li>';
      }).join('');
      this.hidden = false;
      var self = this;
      list.querySelectorAll('[data-vid]').forEach(function (b) { b.addEventListener('click', function () { self.add(b); }); });
    }
    async add(btn) {
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Agregando\u2026';
      var drawer = document.querySelector('cart-drawer');
      var onCartPage = /\/cart\/?$/.test(window.location.pathname);
      var inDrawer = !onCartPage && drawer && typeof drawer.renderContents === 'function';
      var body = { items: [{ id: Number(btn.dataset.vid), quantity: 1 }] };
      if (inDrawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      try {
        var r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        var data = await r.json();
        if (!r.ok) throw new Error(data.description || 'error');
        if (inDrawer) { drawer.classList.remove('is-empty'); data.id = btn.dataset.vid; drawer.renderContents(data); btn.disabled = false; btn.textContent = label; }
        else { window.location.reload(); }
      } catch (e) { btn.disabled = false; btn.textContent = 'Intenta de nuevo'; }
    }
  }
  customElements.define('nl-cross-sell', NlCrossSell);

  var cfgEl = document.getElementById('nlx-config');
  var cfg = { title: 'Complementa tu pedido', limit: 3, fallback: 'mas-vendidos-1', trust: 'Pago seguro con Mercado Pago|Env\u00edos a toda Colombia|Asesor\u00eda por WhatsApp' };
  if (cfgEl) { try { Object.assign(cfg, JSON.parse(cfgEl.textContent)); } catch (e) {} }
  function trustHTML() { return (cfg.trust || '').split('|').filter(Boolean).map(function (t) { return '<span>' + esc(t.trim()) + '</span>'; }).join(''); }
  function mountTrust(scope) {
    var ctas = document.querySelector(scope + ' .cart__ctas');
    if (!ctas || !cfg.trust || ctas.parentNode.querySelector('.nlx-trust')) return;
    var p = document.createElement('p'); p.className = 'nlx-trust'; p.innerHTML = trustHTML();
    ctas.insertAdjacentElement('afterend', p);
  }
  var busy = false;
  async function mountDrawer() {
    mountTrust('#CartDrawer');
    if (cfg.enable === false) return;
    var wrap = document.querySelector('#CartDrawer-CartItems .drawer__cart-items-wrapper');
    if (!wrap || busy) return;
    if (wrap.parentNode.querySelector('nl-cross-sell')) return;
    busy = true;
    var ids = '';
    try { var c = await (await fetch(root + 'cart.js')).json(); ids = c.items.map(function (i) { return i.product_id; }).join(','); } catch (e) {}
    busy = false;
    if (!ids || wrap.parentNode.querySelector('nl-cross-sell')) return;
    var el = document.createElement('nl-cross-sell');
    el.className = 'nlx nlx--drawer';
    el.hidden = true;
    el.dataset.ids = ids; el.dataset.mode = 'drawer'; el.dataset.limit = cfg.limit; el.dataset.fallback = cfg.fallback;
    el.innerHTML = '<p class="nlx-title"></p><ul class="nlx-list" data-list></ul>';
    el.querySelector('.nlx-title').textContent = cfg.title;
    wrap.insertAdjacentElement('afterend', el);
  }
  function watch() {
    mountTrust('#main-cart-footer');
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    mountDrawer();
    var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(mountDrawer, 60); }).observe(d, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();

  // Header fijo sin temblor: apaga el listener de scroll de <sticky-header>
  function calmHeader() {
    var sh = document.querySelector('sticky-header');
    if (!sh) return;
    if (sh.onScrollHandler) window.removeEventListener('scroll', sh.onScrollHandler);
    sh.style.transform = 'none';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', calmHeader); else calmHeader();
})();
